/**
 * Calculates the sum of numeric values for a specified property across all items in an array.
 *
 * @template T - The type of objects in the array.
 * @param array - The array of objects to process.
 * @param key - The property key whose values will be summed. The property should contain numeric values.
 * @returns The total sum of all values for the specified property across all array items.
 */
export function countBy<T>(array: T[], key: keyof T): number {
  return array.reduce((count, item) => count + +item[key], 0);
}

const arr = [
  {
    name: 'a',
    age: 20,
  },
  {
    name: 'b',
    age: 20,
  },
  {
    name: 'c',
    age: 20,
  },
];

countBy(arr, 'age');
